const onAccountBalancesPagePropertyMatch = () => {
  console.log('Lux Inject: Running onAccountBalancesPagePropertyMatch')

  // --- Extract IDs and Dates ---
  const path = window.location.pathname
  const searchParams = new URLSearchParams(window.location.search)

  const urlRegex = /^\/account-balances\/([^?]+)/
  const match = path.match(urlRegex)
  let componentIsLoading = false;

  if (match) {
    const propertyHrId = match[1]
    const startDate = searchParams.get('startDate')
    const endDate = searchParams.get('endDate')

    console.log('Extracted propertyHrId:', propertyHrId)
    console.log('Extracted startDate:', startDate)
    console.log('Extracted endDate:', endDate)

    // State for contacts and multiselect
    let contacts = []
    let selectedContactIds = new Set()
    let isLoading = true
    let hasError = false
    let propertyId = null // Store propertyId for later use
    let currentAbortController = null // For cancelling in-flight requests
    let lastStartDate = null
    let lastEndDate = null
    let isFirstLoad = true
    
    // Get domainId from localStorage
    const authData = JSON.parse(localStorage.getItem('auth') || '{}')
    const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
    const domainId = decodedToken.domainId    
    

    const createMultiselectComponent = () => {
      const multiselectId = 'contact-multiselect-' + Date.now()
      
      // Create multiselect container
      const multiselectContainer = document.createElement('div')
      multiselectContainer.id = multiselectId
      multiselectContainer.style.cssText = `
        position: relative;
        flex: 1;
        margin-right: 8px;
      `

      // Create the main select trigger
      const selectTrigger = document.createElement('div')
      selectTrigger.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        background: white;
        cursor: pointer;
        min-height: 40px;
        transition: border-color 0.3s;
      `
      
      // Create badges container
      const badgesContainer = document.createElement('div')
      badgesContainer.className = 'badges-container'
      badgesContainer.style.cssText = `
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        align-items: center;
      `
      
      // Create placeholder
      const placeholder = document.createElement('span')
      placeholder.className = 'select-placeholder'
      placeholder.style.cssText = 'color: #999;'
      placeholder.textContent = 'Kontakte auswählen...'
      badgesContainer.appendChild(placeholder)
      
      // Create dropdown arrow
      const dropdownArrow = document.createElement('div')
      dropdownArrow.style.cssText = 'margin-left: 8px; flex-shrink: 0;'
      dropdownArrow.innerHTML = `
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
      
      selectTrigger.appendChild(badgesContainer)
      selectTrigger.appendChild(dropdownArrow)

      // Create dropdown container
      const dropdown = document.createElement('div')
      dropdown.style.cssText = `
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: white;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        max-height: 300px;
        overflow-y: auto;
        z-index: 1000;
        display: none;
      `

      // Create search input
      const searchContainer = document.createElement('div')
      searchContainer.style.cssText = `
        padding: 8px;
        border-bottom: 1px solid #f0f0f0;
      `
      const searchInput = document.createElement('input')
      searchInput.type = 'text'
      searchInput.placeholder = 'Suchen...'
      searchInput.style.cssText = `
        width: 100%;
        padding: 6px 8px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        font-size: 14px;
        outline: none;
      `
      searchContainer.appendChild(searchInput)
      dropdown.appendChild(searchContainer)

      // Create options container
      const optionsContainer = document.createElement('div')
      optionsContainer.style.cssText = `
        padding: 4px;
      `
      dropdown.appendChild(optionsContainer)

      multiselectContainer.appendChild(selectTrigger)
      multiselectContainer.appendChild(dropdown)

      // Crown SVG icon
      const crownSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-left: 4px; color: #facc15;">
        <path d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5Z" fill="currentColor"/>
        <path d="M19 16V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V16" stroke="currentColor" stroke-width="2"/>
      </svg>`

      const renderOptions = (searchTerm = '') => {
        optionsContainer.innerHTML = ''
        
        const filteredContacts = contacts.filter(contact => 
          contact.name.toLowerCase().includes(searchTerm.toLowerCase())
        )

        if (filteredContacts.length === 0) {
          optionsContainer.innerHTML = `
            <div style="padding: 12px; text-align: center; color: #999;">
              Keine Kontakte gefunden
            </div>
          `
          return
        }

        filteredContacts.forEach(contact => {
          const option = document.createElement('label')
          option.style.cssText = `
            display: flex;
            align-items: center;
            padding: 8px 12px;
            cursor: pointer;
            border-radius: 4px;
            transition: background-color 0.2s;
          `
          option.innerHTML = `
            <input type="checkbox" ${selectedContactIds.has(contact.contactId) ? 'checked' : ''} 
              style="margin-right: 8px; cursor: pointer;" />
            <span style="flex: 1;">${contact.name}</span>
            ${contact.hasCouncilRole ? crownSvg : ''}
          `
          
          option.addEventListener('mouseenter', () => {
            option.style.backgroundColor = '#f5f5f5'
          })
          option.addEventListener('mouseleave', () => {
            option.style.backgroundColor = 'transparent'
          })

          const checkbox = option.querySelector('input')
          checkbox.addEventListener('change', (e) => {
            e.stopPropagation()
            if (checkbox.checked) {
              selectedContactIds.add(contact.contactId)
            } else {
              selectedContactIds.delete(contact.contactId)
            }
            updateSelectTrigger()
          })

          option.addEventListener('click', (e) => {
            if (e.target.tagName !== 'INPUT') {
              e.preventDefault()
              checkbox.checked = !checkbox.checked
              checkbox.dispatchEvent(new Event('change'))
            }
          })

          optionsContainer.appendChild(option)
        })
      }

      const updateSelectTrigger = () => {
        const selectedContacts = contacts.filter(c => selectedContactIds.has(c.contactId))
        const badgesContainer = selectTrigger.querySelector('.badges-container')
        badgesContainer.innerHTML = ''
        
        if (selectedContacts.length === 0) {
          const placeholder = document.createElement('span')
          placeholder.className = 'select-placeholder'
          placeholder.style.cssText = 'color: #999;'
          placeholder.textContent = 'Kontakte auswählen...'
          badgesContainer.appendChild(placeholder)
        } else {
          selectedContacts.forEach(contact => {
            const badge = document.createElement('div')
            badge.style.cssText = `
              display: inline-flex;
              align-items: center;
              background: #f5f5f5;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              padding: 2px 8px;
              font-size: 13px;
              gap: 4px;
            `
            
            // Contact name
            const nameSpan = document.createElement('span')
            nameSpan.textContent = contact.name
            badge.appendChild(nameSpan)
            
            // Crown icon for council members
            if (contact.hasCouncilRole) {
              const crownIcon = document.createElement('span')
              crownIcon.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="color: #facc15;">
                <path d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5Z" fill="currentColor"/>
                <path d="M19 16V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V16" stroke="currentColor" stroke-width="2"/>
              </svg>`
              badge.appendChild(crownIcon)
            }
            
            // Remove button
            const removeBtn = document.createElement('button')
            removeBtn.style.cssText = `
              background: none;
              border: none;
              cursor: pointer;
              padding: 0;
              margin-left: 4px;
              display: inline-flex;
              align-items: center;
              color: #666;
              transition: color 0.2s;
            `
            removeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`
            removeBtn.addEventListener('mouseenter', () => {
              removeBtn.style.color = '#000'
            })
            removeBtn.addEventListener('mouseleave', () => {
              removeBtn.style.color = '#666'
            })
            removeBtn.addEventListener('click', (e) => {
              e.stopPropagation()
              selectedContactIds.delete(contact.contactId)
              updateSelectTrigger()
              renderOptions(searchInput.value)
            })
            badge.appendChild(removeBtn)
            
            badgesContainer.appendChild(badge)
          })
        }
      }

      // Toggle dropdown
      selectTrigger.addEventListener('click', () => {
        const isOpen = dropdown.style.display === 'block'
        dropdown.style.display = isOpen ? 'none' : 'block'
        if (!isOpen) {
          searchInput.value = ''
          renderOptions()
          searchInput.focus()
        }
      })

      // Search functionality
      searchInput.addEventListener('input', (e) => {
        renderOptions(e.target.value)
      })

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!multiselectContainer.contains(e.target)) {
          dropdown.style.display = 'none'
        }
      })

      // Prevent dropdown from closing when clicking inside
      dropdown.addEventListener('click', (e) => {
        e.stopPropagation()
      })

      // Expose updateSelectTrigger function
      multiselectContainer.updateSelectTrigger = updateSelectTrigger
      
      return multiselectContainer
    }

    // Function to fetch existing audit data
    const fetchExistingAuditData = async (currentStartDate, currentEndDate, multiselectComponent) => {
      if (!propertyId || !domainId) {
        console.log('Cannot fetch audit data: missing propertyId or domainId')
        return
      }

      // Cancel previous request if exists
      if (currentAbortController) {
        currentAbortController.abort()
      }

      currentAbortController = new AbortController()

      try {
        // Show loading state
        if (multiselectComponent) {
          multiselectComponent.style.opacity = '0.5'
          multiselectComponent.style.pointerEvents = 'none'
        }

        const response = await fetch(
          `/api/audit?domainId=${domainId}&propertyId=${propertyId}&startDate=${currentStartDate}&endDate=${currentEndDate}`,
          {
            signal: currentAbortController.signal
          }
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch audit data: ${response.status}`)
        }

        const data = await response.json()
        
        if (data.exists && data.contactIds) {
          // Update selection with data from backend
          selectedContactIds.clear()
          data.contactIds.forEach(id => selectedContactIds.add(id))
          console.log('Loaded existing audit data with contacts:', data.contactIds)
        } else if (isFirstLoad) {
          // On first load with no existing data, select all councils
          selectedContactIds.clear()
          contacts.forEach(contact => {
            if (contact.hasCouncilRole) {
              selectedContactIds.add(contact.contactId)
            }
          })
          console.log('No existing audit data on first load, selected all councils')
        }
        // If not first load and no data exists, keep current selection
        
        isFirstLoad = false

        // Update the multiselect display
        if (multiselectComponent && multiselectComponent.updateSelectTrigger) {
          multiselectComponent.updateSelectTrigger()
        }

      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching audit data:', error)
        }
      } finally {
        // Remove loading state
        if (multiselectComponent) {
          multiselectComponent.style.opacity = '1'
          multiselectComponent.style.pointerEvents = 'auto'
        }
        currentAbortController = null
      }
    }

    const fetchDataAndCreateUI = async () => {
      try {
        // Get auth token
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token
        if (!token) {
          throw new Error('No auth token found')
        }

        // Fetch property data
        const propertyResponse = await fetch(
          `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
          {
            headers: {
              'Accept': 'application/json; charset=utf-8',
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        )

        if (!propertyResponse.ok) {
          throw new Error(`Failed to fetch property: ${propertyResponse.status}`)
        }

        const propertyData = await propertyResponse.json()
        propertyId = propertyData.id // Store in outer scope variable

        // Fetch unit contracts
        const contractsResponse = await fetch(
          `/services/pmp-accounting/api/v1/unit-contract?propertyId=${propertyId}`,
          {
            headers: {
              'Accept': '*/*',
              'Authorization': `Bearer ${token}`
            }
          }
        )

        if (!contractsResponse.ok) {
          throw new Error(`Failed to fetch contracts: ${contractsResponse.status}`)
        }

        const contractsData = await contractsResponse.json()

        // Process contacts
        const contactMap = new Map()
        contractsData.forEach(contract => {
          if (contract.contacts && Array.isArray(contract.contacts)) {
            contract.contacts.forEach(contact => {
              if (!contactMap.has(contact.contactId)) {
                contactMap.set(contact.contactId, {
                  contactId: contact.contactId,
                  name: contact.name,
                  hasCouncilRole: contact.role && contact.role.includes('COUNCIL')
                })
              } else {
                // Update council role if found in another contract
                const existingContact = contactMap.get(contact.contactId)
                if (contact.role && contact.role.includes('COUNCIL')) {
                  existingContact.hasCouncilRole = true
                }
              }
            })
          }
        })

        contacts = Array.from(contactMap.values())
        
        // Pre-select council members
        contacts.forEach(contact => {
          if (contact.hasCouncilRole) {
            selectedContactIds.add(contact.contactId)
          }
        })

        isLoading = false
        hasError = false
      } catch (error) {
        console.error('Error fetching data:', error)
        isLoading = false
        hasError = true
      }
    }

    const waitForPageLoad = setInterval(async () => {
      const shareModalContent = document.querySelector('.ant-modal-body')
      if (shareModalContent) {
        const existingButtonWrapper = document.querySelector('.buttonWrapper')
        const largeButton = document.querySelector('.large-button')
        
        
        if (!existingButtonWrapper && largeButton && !componentIsLoading) {
          componentIsLoading = true
          loading = true
          // Fetch data
          await fetchDataAndCreateUI()

          // Create wrapper with flex layout
          const buttonWrapper = document.createElement('div')
          buttonWrapper.className = 'buttonWrapper ant-col ant-col-24'
          buttonWrapper.style.cssText = 'padding: 8px; display: flex; align-items: center;'

          // Create multiselect
          const multiselect = createMultiselectComponent()
          
          // Fetch existing audit data after contracts are loaded
          const dateInputs = shareModalContent.querySelectorAll('input')
          if (dateInputs.length >= 4) {
            const currentStartDate = dateInputs[2].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')
            const currentEndDate = dateInputs[3].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')
            lastStartDate = currentStartDate
            lastEndDate = currentEndDate
            
            await fetchExistingAuditData(currentStartDate, currentEndDate, multiselect)
          } else {
            // If we can't get dates, just update with current selection
            if (multiselect.updateSelectTrigger) {
              multiselect.updateSelectTrigger()
            }
          }

          // Set up date monitoring
          const dateMonitorInterval = setInterval(() => {
            const dateInputs = shareModalContent.querySelectorAll('input')
            if (dateInputs.length >= 4) {
              const currentStartDate = dateInputs[2].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')
              const currentEndDate = dateInputs[3].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')
              
              // Check if dates have changed
              if (currentStartDate !== lastStartDate || currentEndDate !== lastEndDate) {
                console.log('Dates changed:', { 
                  from: { start: lastStartDate, end: lastEndDate }, 
                  to: { start: currentStartDate, end: currentEndDate } 
                })
                lastStartDate = currentStartDate
                lastEndDate = currentEndDate
                
                // Fetch new data
                fetchExistingAuditData(currentStartDate, currentEndDate, multiselect)
              }
            }
          }, 500)

          // Clean up interval when modal is closed
          const modalObserver = new MutationObserver((mutations) => {
            const modalStillExists = document.querySelector('.ant-modal-body')
            if (!modalStillExists) {
              clearInterval(dateMonitorInterval)
              modalObserver.disconnect()
              console.log('Modal closed, stopped date monitoring')
            }
          })
          modalObserver.observe(document.body, { childList: true, subtree: true })

          // Clone and modify button
          const shareAuditButton = largeButton.cloneNode(true)
          shareAuditButton.textContent = 'Belegprüfung freigeben'
          shareAuditButton.style.flex = '0 0 auto'

          // Handle loading and error states
          if (isLoading) {
            shareAuditButton.disabled = true
            shareAuditButton.style.opacity = '0.5'
            multiselect.style.opacity = '0.5'
            multiselect.style.pointerEvents = 'none'
          } else if (hasError) {
            shareAuditButton.disabled = true
            shareAuditButton.style.opacity = '0.5'
            multiselect.style.display = 'none'
          }

          shareModalContent.insertBefore(
            buttonWrapper,
            shareModalContent.lastChild.nextSibling
          )

          componentIsLoading = false
          
          buttonWrapper.appendChild(multiselect)
          buttonWrapper.appendChild(shareAuditButton)

          shareAuditButton.addEventListener('click', async () => {
            // Check if we have selected contacts
            if (selectedContactIds.size === 0) {
              alert('Bitte wählen Sie mindestens einen Kontakt aus.')
              return
            }

            // Disable button and update text
            shareAuditButton.disabled = true
            shareAuditButton.textContent = 'freigeben ...'

            try {
              // Get auth token
              const authData = JSON.parse(localStorage.getItem('auth') || '{}')
              const token = authData.token
              if (!token) {
                throw new Error('No auth token found')
              }

              const validUntilDate = shareModalContent.querySelectorAll('input')[0].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1');
              const oneDayInSeconds = 24*60*60;
              const tokenValidityInSeconds = Math.round((new Date(validUntilDate) - new Date())/1000) + oneDayInSeconds

              const selectedStartDate = shareModalContent.querySelectorAll('input')[2].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1');
              const selectedEndDate = shareModalContent.querySelectorAll('input')[3].value.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1');


              const host = window.location.host

              // Prepare payload
              const payload = {
                contactIds: Array.from(selectedContactIds),
                propertyHrId: propertyHrId,
                propertyId: propertyId,
                startDate: selectedStartDate,
                endDate: selectedEndDate,
                tokenValidityInSeconds,
                host
              }

              console.log('Sending audit request:', payload)

              // Make API call
              const response = await fetch('/api/audit', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
              })

              if (response.ok) {
                // Success - update button with checkmark
                shareAuditButton.innerHTML = `
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="margin-right: 4px; vertical-align: middle;">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Belegprüfung freigegeben
                `
                shareAuditButton.style.color = '#059669' // Green color
              } else {
                // Error - update button and disable
                shareAuditButton.textContent = 'Freigabe fehlgeschlagen'
                shareAuditButton.style.color = '#dc2626' // Red color
              }
            } catch (error) {
              // Network or other error
              shareAuditButton.textContent = 'Freigabe fehlgeschlagen'
              shareAuditButton.style.color = '#dc2626' // Red color
              shareAuditButton.disabled = true
              console.error('Error making audit request:', error)
            }
          })
        }
      }
    }, 500)
  }
}
